import { Card, Grid, Tab, Tabs } from "@mui/material";
import React, { SyntheticEvent, useState } from "react";
import Layout from "components/Layout";
import Strategy from "components/holdings/Management/Strategy";

const ManagementPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Layout title="Management">
      <Card>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Strategy" />
        </Tabs>
        <Grid container>
          {activeTab === 0 && (
            <Grid item xs={12} padding={2}>
              <Strategy />
            </Grid>
          )}
        </Grid>
      </Card>
    </Layout>
  );
};

export default ManagementPage;
